import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CommunityGalleryPage } from "@/features/community/components/community-gallery-page";

// Galería comunitaria de un producto (slot aditivo del detalle de Wave 0).
function CommunityGalleryRoutePage() {
  const params = communityProductRoute.useParams();
  return <CommunityGalleryPage productId={params().productId} />;
}

export const communityProductRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/community/product/$productId",
  component: CommunityGalleryRoutePage,
});
